var _LogStatusForApi;

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { timeStampNow, ConsoleApiName, ErrorSource, initConsoleObservable } from '@datadog/browser-core';
import { StatusType } from '../logger/isAuthorized';
import { createErrorFieldFromRawError } from '../createErrorFieldFromRawError';
export var LogStatusForApi = (_LogStatusForApi = {}, _defineProperty(_LogStatusForApi, ConsoleApiName.log, StatusType.info), _defineProperty(_LogStatusForApi, ConsoleApiName.debug, StatusType.debug), _defineProperty(_LogStatusForApi, ConsoleApiName.info, StatusType.info), _defineProperty(_LogStatusForApi, ConsoleApiName.warn, StatusType.warn), _defineProperty(_LogStatusForApi, ConsoleApiName.error, StatusType.error), _LogStatusForApi);
export function startConsoleCollection(configuration, lifeCycle) {
  var consoleSubscription = initConsoleObservable(configuration.forwardConsoleLogs).subscribe(function (log) {
    var _a;

    var collectedData = {
      rawLogsEvent: {
        date: timeStampNow(),
        message: log.message,
        origin: ErrorSource.CONSOLE,
        error: log.error && createErrorFieldFromRawError(log.error),
        status: LogStatusForApi[log.api]
      },
      messageContext: (_a = log.error) === null || _a === void 0 ? void 0 : _a.context,
      domainContext: {
        handlingStack: log.handlingStack
      }
    };
    lifeCycle.notify(0
    /* LifeCycleEventType.RAW_LOG_COLLECTED */
    , collectedData);
  });
  return {
    stop: function stop() {
      consoleSubscription.unsubscribe();
    }
  };
}